/**
 * EAA-2068: who sees the accounts list at all. `/console/accounts` and the
 * app-detail "Tài khoản" sub-view render the same board, so they must agree on
 * this one predicate — the app tab falls back to its "Đồng bộ" view exactly when
 * this is false.
 *
 * The three keys are the ones the board has actions for (issue / reset /
 * delete); the list read itself has no capability of its own.
 */
export const ACCOUNT_LIST_CAPABILITIES = [
    'console.accounts.issue',
    'console.accounts.reset',
    'console.accounts.delete',
] as const;

export function canListAccounts(can: (key: string) => boolean): boolean {
    return ACCOUNT_LIST_CAPABILITIES.some((key) => can(key));
}
